/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckRuleType } from './PaxCheckRuleType';
import {
    PaxCheckRuleTypeFromJSON,
    PaxCheckRuleTypeFromJSONTyped,
    PaxCheckRuleTypeToJSON,
    PaxCheckRuleTypeToJSONTyped,
} from './PaxCheckRuleType';

/**
 * Origin of the rule
 * @export
 * @interface PaxCheckRuleOrigin
 */
export interface PaxCheckRuleOrigin {
    /**
     * 
     * @type {PaxCheckRuleType}
     * @memberof PaxCheckRuleOrigin
     */
    type: PaxCheckRuleType;
    /**
     * Rule origin country
     * @type {string}
     * @memberof PaxCheckRuleOrigin
     */
    country: string;
}



/**
 * Check if a given object implements the PaxCheckRuleOrigin interface.
 */
export function instanceOfPaxCheckRuleOrigin(value: object): value is PaxCheckRuleOrigin {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function PaxCheckRuleOriginFromJSON(json: any): PaxCheckRuleOrigin {
    return PaxCheckRuleOriginFromJSONTyped(json, false);
}

export function PaxCheckRuleOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRuleOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'type': PaxCheckRuleTypeFromJSON(json['type']),
        'country': json['country'],
    };
}

export function PaxCheckRuleOriginToJSON(json: any): PaxCheckRuleOrigin {
    return PaxCheckRuleOriginToJSONTyped(json, false);
}

export function PaxCheckRuleOriginToJSONTyped(value?: PaxCheckRuleOrigin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': PaxCheckRuleTypeToJSON(value['type']),
        'country': value['country'],
    };
}

